import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-document-history',
  templateUrl: './document-history.component.html',
  styleUrl: './document-history.component.scss'
})
export class DocumentHistoryComponent {
  constructor(public dialogRef: MatDialogRef<DocumentHistoryComponent>, @Inject(MAT_DIALOG_DATA) public data: { documentVersions: any[] }) { }
}
